import React, { useState, useEffect } from "react";
import axios from "axios";
import api , { API_BASE_URL } from "../../src/utils/api";

const API_TEMPLATES = `/letters`;

const LoadTemplate = ({ onTemplateLoad }) => {
  const [templates, setTemplates] = useState([]);
  const [selectedTemplateId, setSelectedTemplateId] = useState("");

  // ✅ Fetch Templates on Component Mount
  useEffect(() => {
    api.get(API_TEMPLATES)
      .then(response => setTemplates(response.data))
      .catch(error => console.error("Error fetching templates:", error));
  }, []);

  // ✅ Load Selected Template & Send to CoverLetters
  const handleTemplateSelect = async (e) => {
    const templateId = e.target.value;
    setSelectedTemplateId(templateId);

    if (!templateId) {
      return;
    }

    try {
      const response = await api.get(`${API_TEMPLATES}/${templateId}`);
      onTemplateLoad(response.data); // ✅ Send Data to CoverLetters.js
    } catch (error) {
      console.error("Error fetching template details:", error);
    }
  };

  return (
    <div style={{ textAlign: "center", padding: "10px", maxWidth: "600px", margin: "0 auto" }}>
      <h2 style={{ fontSize: "20px", color: "#333", marginBottom: "10px" }}>Load a Saved Template</h2>

      {/* Template Dropdown */}
      <select 
        value={selectedTemplateId} 
        onChange={handleTemplateSelect} 
        style={{ width: "100%", padding: "8px", borderRadius: "5px", border: "1px solid #ccc" }}>
        <option value="">Choose a Template</option>
        {templates.map(template => (
          <option key={template.id} value={template.id}>
            {template.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LoadTemplate;
